// Anchors for deep links into the Settings page.
//
// Here rather than in Settings.tsx so a component that links to a section does
// not have to import the whole page to name it. The swipe deck's empty state
// links to discovery; importing Settings for a string would drag the entire
// settings surface into the deck's bundle.

/** "Who you see" — gender preference and age range. */
export const DISCOVERY_SECTION_ID = 'discovery';
